import React from 'react';
function MakeGlobal({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect width="6.5" height="6.5" x="13.5" y="13" rx="1.3" />
      <rect width="6.5" height="6.5" x="13.5" y="4" rx="1.3" />
      <rect width="6.5" height="6.5" x="4" y="13" rx="1.3" />
      <rect width="6.5" height="6.5" x="4" y="4" rx="1.3" />
    </svg>
  );
}

export default MakeGlobal;
